import React, { useEffect, useState } from 'react';
import { Nav, NavItem } from '../../compat/BootstrapCompat';
import PropTypes from 'prop-types';

import Banner from '../reusable/Banner';
import BannerMobile from '../reusable/BannerMobile';
import RPPComparisonTable from './RPPComparisonTable';

import { fixBanner } from '../../../../services/v2/productsService';

/**
 * OldPackageSelection.
 * Component for handling product package selection.
 *
 * @author  Manny
 * @param   {Object}      props.coupon           Coupon object.
 * @param   {String}      props.method           Optional industry params.
 * @param   {Function}    props.onSelectPackage  Handles onClick for selecting a package.
 * @param   {Object}      props.productPackages  List of packages for the product.
 * @param   {Object}      props.productsConfig   Product configurations.
 * @param   {String}      props.selectedIndustry Name of selected industry.
 * @param   {String}      props.selectedPackage  Name of selected package.
 * @returns {JSX.Element} The component markup.
 */

const OldPackageSelection = ({
  coupon,
  method,
  onSelectPackage,
  productPackages,
  productsConfig,
  selectedIndustry,
  selectedPackage
}) => {
  const [activeKey, setActiveKey] = useState('1');
  const [packageKey, setPackageKey] = useState(selectedPackage);

  useEffect(() => {
    window.addEventListener('scroll', fixBanner);

    let packagesLength = 0;

    if (productsConfig != null && selectedIndustry) {
      packagesLength = Object.keys(productsConfig.industries[selectedIndustry].packages).length;
      packagesLength = packagesLength.toString();
      if (selectedIndustry === 'property_developers_trades_services') {
        packagesLength = '2';
      }
      changePackage(packagesLength, 'basic');
    } else if (productsConfig != null) {
      packagesLength = Object.keys(
        productsConfig.industries['real_estate_agencies_and_valuers'].packages
      ).length;
      packagesLength = packagesLength.toString();
      setActiveKey(packagesLength);
    }

    return () => {
      window.removeEventListener('scroll', fixBanner);
    };
  }, [productPackages]);

  const changePackage = (newActiveKey, newPackageKey) => {
    setActiveKey(newActiveKey);
    setPackageKey(newPackageKey);
  };

  useEffect(() => {
    setPackageKey(selectedPackage);
  }, [selectedPackage]);

  const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);

  let classNames = require('classnames');
  let containerClass = classNames({
    'col-sm-12': isMobile === false,
    'col-sm-12 no-padding': isMobile === true
  });

  // addresses packageKey differences between packages that are not in other industries
  const uniquePackageKeys = ['basic1UN', 'pro', 'one_month']
  const getPackageKey = (packageKey) => {
    if (packageKey in productPackages)
      return packageKey
    return Object.keys(productPackages).filter(e => uniquePackageKeys.includes(e))[0];
  }

  let industryKey = selectedIndustry ? selectedIndustry : 'real_estate_agencies_and_valuers';
  return (
    <div className='row no-margin'>
      <div className={containerClass}>
        {coupon && Object.keys(coupon).length > 0 && coupon.blueBoxText !== null && (
          <div className='row no-margin page-dim padded-sides'>
            <div className='col-sm-12 discount-alert blue-bg no-margin captions-semibold'>
              <span>{coupon.blueBoxText}</span>
            </div>
          </div>
        )}
        {isMobile && coupon && Object.keys(coupon).length > 0 && coupon.blueBoxText !== null && (
          <br />
        )}
        {isMobile === false && (
          <div className='row no-margin margin-bottom-100 page-dim white-bg'>
            <div className='col-xs-12 panel-container'>
              <Banner
                onSelectPackage={onSelectPackage}
                industryPackage={productsConfig.industries[industryKey]}
                industryKey={industryKey}
                product='rpp'
                buyNow={method ? method.includes('buyNow') : false}
              />
              <RPPComparisonTable
                addons={productsConfig.addons}
                buyNow={method ? method.includes('buyNow') : false}
                features={productsConfig.features}
                industryPackage={productPackages}
                industryKey={industryKey}
                usersGeo={productsConfig.users_geo}
              />
            </div>
          </div>
        )}
        {isMobile && packageKey && productPackages[getPackageKey(packageKey)] && (
          <div className='row no-margin margin-bottom-100'>
            <div className='col-xs-12 white-bg padding-bottom-15'>
              <div className='row off-white-bg'>
                <div className='font-14 text-center'>{productPackages[getPackageKey(packageKey)].blurb}</div>
                <br />
              </div>
              <div className='row'>
                <Nav bsStyle='tabs' id='rpp-nav-tabs' activeKey={activeKey}>
                  {Object.keys(productPackages).map(function (singlePackage, index) {
                    let item = productPackages[singlePackage];
                    let counter = index + 1;
                    counter = counter.toString();
                    if (
                      ((method ? method.includes('buyNow') : false) && item.key === 'trial') ||
                      item.visible === false
                    ) {
                      return;
                    } else {
                      return (
                        <NavItem
                          className={index == productPackages.length-1 ? '' : 'last-rpp-nav'}
                          eventKey={counter}
                          onClick={() => {
                            changePackage(counter, item.key);
                          }}
                          key={counter}
                        >
                          {item.title}
                        </NavItem>
                      );
                    }
                  })}
                </Nav>
                <BannerMobile
                  onSelectPackage={onSelectPackage}
                  packages={productPackages}
                  packageKey={getPackageKey(packageKey)}
                  industryKey={industryKey}
                  product='rpp'
                />
                <RPPComparisonTable
                  addons={productsConfig.addons}
                  features={productsConfig.features}
                  industryKey={industryKey}
                  industryPackage={productPackages}
                  isMobile={true}
                  packageKey={getPackageKey(packageKey)}
                  usersGeo={productsConfig.users_geo}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

OldPackageSelection.propTypes = {
  coupon: PropTypes.object,
  method: PropTypes.string,
  onSelectPackage: PropTypes.func.isRequired,
  productPackages: PropTypes.object.isRequired,
  productsConfig: PropTypes.object.isRequired,
  selectedIndustry: PropTypes.string.isRequired,
  selectedPackage: PropTypes.string.isRequired
};

export default OldPackageSelection;
